import React from 'react'
import { Link, withRouter } from 'react-router-dom';

import moment from 'moment';

import { Section, Table, InfosBar, Empty, ProfilePicture, Text } from 'components';
import { Container, Icon } from 'semantic-ui-react'

import { BreadcrumbHelper, Typeof } from 'utils';

const INVOICES_PER_PAGE = 10;

class InvoiceListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      invoices: props.invoices,
      invoiceCriteria: '',
      showSensorCreateModal: false
    };

    this.handleInvoiceSearch = this.handleInvoiceSearch.bind(this);

    this.handleInvoiceSelect = this.handleInvoiceSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Factures');
    BreadcrumbHelper.flush();
  }

  handleInvoiceSearch(criteria) {

    this.setState({
      invoiceCriteria: criteria
    });
  }

  handleInvoiceSelect(invoice) {
    //this.props.history.push(`/invoices/${invoice.uuid}`);
  }

  render() {

    const { invoices } = this.state;

    let columns = [
        {
            id: 'name',
            header: 'Clinique',
            value: (invoice) => invoice.name,
            fit: true
        },
        {
            id: 'email',
            header: 'Email',
            value: (invoice) => invoice.email,
        },
        {
          id: 'date',
          header: 'Date',
          value: (invoice) => Typeof.string(invoice.date) ? moment(invoice.date).format('DD/MM/YYYY') : undefined,
          render: (invoice) => Typeof.string(invoice.date) ? <Text>{moment(invoice.date).format('DD/MM/YYYY')}</Text> : <Empty />,
          fit: true
        },
        {
          id: 'type',
          header: 'Type',
          value: (invoice) => invoice.filename.substring(0, 3),
          fit: true
        },
        {
          id: 'amount',
          header: 'Montant',
          value: (invoice) => invoice.total,
          render: (invoice) => {
            return `${invoice.total} ${invoice.devise}`
          },
          fit: true
        },
        {
          id: 'file',
          header: 'Fichier',
          value: (invoice) => invoice.filename,
          render: (invoice) => {
            return (<button id="downloadBtn" onClick={() => downloadInvoice(invoice.filename, invoice.filepath)} value="download">{invoice.filename}</button>)
          },
          fit: true
        }
      ];

      const downloadInvoice = (filename, filepath) => {
        fetch('https://api.quote.equimetre.com/download?filename=' + filename + '&filepath=' + filepath)
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );
  
                // Append to html link element page
                document.body.appendChild(link);
  
                // Start download
                link.click();
  
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });
      }

    return (
      <React.Fragment>
        <Container>

          {/* Users */}
          <Section title="Factures" onSearch={this.handleInvoiceSearch} actions={[]}>

            {invoices.length > 0 ? (

              <React.Fragment>

                {/* Number of available invoices */}
                <InfosBar mode="column">
                  <span>{invoices.length > 1 ? `${invoices.length} factures disponibles` : '1 facture disponible'}</span>
                </InfosBar>

                {/* invoices list */}
                <Table columns={columns}
                  criteria={this.state.invoiceCriteria}
                  items={invoices}
                  itemsPerPage={INVOICES_PER_PAGE}
                  onSelect={this.handleInvoiceSelect}
                  messageEmpty="Aucune facture ne correspond à votre recherche"
                  getRowClass={(invoice) => !invoice.active ? 'warning' : undefined}
                />

              </React.Fragment>

            ) : (

              // No invoice available
              <InfosBar mode="row">
                <span>Aucune facture disponible</span>
              </InfosBar>

            )}

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(InvoiceListScene);
